<template>
  <div id="wrapper-input-product-filter" :class="modifiedStyle">
    <span>{{ radioGroupLabel }}</span>
    <b-form-group :id="`${tabId}_input-product-filter`" :class="modifiedStyle" class="wrapper-product-filter">
      <b-form-radio
        @change="onChange($event)"
        v-for="(item, key) in productAccess"
        v-bind:key="key"
        v-model="selectedProduct"
        class="product-item"
        :class="[item.internal_value, item.disabled, item.class, {active: item.internal_id === selectedProduct, 'btn colorful radio_option': true }]"
        :name="`${item.internal_value}-item`"
        :value="item.internal_id"
        :disabled="item.disabled">
        <i class="fas fa-lg" :class="[item.icon]"/> {{item.label}} {{additionalText}}
      </b-form-radio>
    </b-form-group>
  </div>
</template>

<script>
/* eslint-disable */ 
export default {
  props: {
    // modifiedStyle adds a class from a prop to modify the style of these radio buttons. See css for variations.
    modifiedStyle: {
      default: null,
      type: String,
    },
    defaultProduct: {
      default: null,
      type: Number,
    },
    productFilterLabel: {
      default: null,
      type: String,
    },
    emitToMethod: {
      default: null,
      type: String,
    },
    productAccessData: {
      default: null,
      type: Array,
    },
    tabId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      radioGroupLabel: '',
      selectedProduct: '',
      productAccess: [],
      productItems: [ // Initial product selection on page load
        {
          internal_value: 'auto',
          internal_id: 1,
          label: 'Auto',
          icon: 'fa-car',
          disabled: false,
          class: 'auto_filter',
        },
        {
          internal_value: 'home',
          internal_id: 21,
          label: 'Home',
          icon: 'fa-home',
          disabled: false,
          class: 'home_filter',
        },
        {
          internal_value: 'condo',
          internal_id: 18,
          label: 'Condo',
          icon: 'fa-hotel',
          disabled: false,
          class: 'condo_filter',
        },
        {
          internal_value: 'renters',
          internal_id: 12,
          label: 'Renters',
          icon: 'fa-building',
          disabled: false,
          class: 'renter_filter',
        },
      ],
    };
  },
  methods: {
    onChange(value) {
      /* emitToMethod is a prop set from the parent component.
      *  It's a method to trigger, typically, changes/updates to page data sitting in the parent component.
      *  value comes from the selected radio button's value.
      */
      this.$emit(this.emitToMethod, value);
    },
    updateProductOptions() {
      if(this.productAccessData.includes(1))
        this.selectedProduct=1;
      if(this.productAccessData.includes(1)===false)
        this.selectedProduct=18;
      if(this.productAccessData.includes(1)===false && this.productAccessData.includes(18)===false)
        this.selectedProduct=21;
      if(this.productAccessData.includes(1)===false && this.productAccessData.includes(21)===false && this.productAccessData.includes(18)===false)
        this.selectedProduct=12;
      for (let pCnt = 0; pCnt < this.productAccessData.length; pCnt += 1) {
        for (let tCnt = 0; tCnt < this.productItems.length; tCnt += 1) {
          if (this.productItems[tCnt].internal_id === this.productAccessData[pCnt]) {
            this.productAccess.push(this.productItems[tCnt]);
          }
        }
      }
     },
  },
  mounted() {
    this.updateProductOptions();
  },
  created() {
    this.radioGroupLabel = this.productFilterLabel ? this.productFilterLabel : 'Product:';
    this.selectedProduct = this.defaultProduct ? this.defaultProduct : 1;
  },
  computed: {
    additionalText() {
      return (this.modifiedStyle === 'simple-buttons') ? '' : '';
    },
  },
  watch: {
    'fieldData.field_value': function fieldData(newValue) {
      sessionStorage.setItem(this.fieldData.field_name, newValue);
    },
    productAccessData: function productAccessData() {
      this.updateProductOptions();
    },
  },
};
</script>

<style>
#wrapper-input-product-filter .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: none !important;
}
  [id$="input-product-filter"], [id$="input-product-filter"] div.custom-radio {
    display:inline-block;
    margin-bottom: 0px;
    font-size: 0.75rem;
  }
  [id$="input-product-filter"] div.custom-radio {
    border-right: 1px solid #cecece;
    padding: 0;
    margin-left: -10px;
    margin-right: 10px;
    border-radius: 0px;
  }
  [id$="input-product-filter"] div.custom-radio:hover, [id$="input-product-filter"] div.custom-radio label:hover {
    cursor: pointer;
  }
  [id$="input-product-filter"] div.custom-radio:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  [id$="input-product-filter"] div.custom-radio:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  [id$="input-product-filter"].simple-buttons div.custom-radio:last-child {
    border-right: 0.1em solid;
  }
  [id$="input-product-filter"] .product-item .custom-control-label::before {
    position: fixed !important;
    color:red;
  }
  /* default grayed for unavailable products */
  [id$="input-product-filter"] .product-item, [id$="input-product-filter"] .product-item input:disabled + label {
    color: #BBB;
  }
  /* product brand colors */
  [id$="input-product-filter"] .product-item.auto {
    color: #333399;
  }
  [id$="input-product-filter"] .product-item.home {
    color: #669999;
  }
  [id$="input-product-filter"] .product-item.condo {
    color: #996699;
  }
  [id$="input-product-filter"] .product-item.renters {
    color: #7BBBC7;
  }
  /* selected product class */
  /* Simple button styles */
  #wrapper-input-product-filter.simple-buttons {
    display: inline-block;
  }
  [id$="input-product-filter"].simple-buttons {
    display:inline-block;
    font-size:0.75rem;
    margin-right: 2.25rem;
  }
  [id$="input-product-filter"].simple-buttons .product-item {
    padding: 0.3em 0.3em;
    align-items: center;
    justify-content: space-evenly;
    margin: 0.3rem;
    border: solid 0.1em;
  }
  [id$="input-product-filter"].simple-buttons .product-item .custom-control-label {
    padding: 0.1em 1.75em;
  }
  [id$="input-product-filter"].simple-buttons .product-item .custom-control-label::before {
    position: fixed;
    color:red;
  }
  /* default grayed for unavailable products */
  [id$="input-product-filter"].simple-buttons .product-item, [id$="input-product-filter"].simple-buttons .product-item input:disabled + label {
    color: #BBB;
  }
  /* product brand colors */
  [id$="input-product-filter"].simple-buttons .product-item.auto {
    color: #333399;
  }
  [id$="input-product-filter"].simple-buttons .product-item.home {
    color: #669999;
  }
  [id$="input-product-filter"].simple-buttons .product-item.condo {
    color: #996699;
  }
  [id$="input-product-filter"].simple-buttons .product-item.renters {
    color: #7BBBC7;
  }
  [id$="input-product-filter"].simple-buttons .product-item.active .custom-control-label {
    border-bottom: none;
  }
  [id$="input-product-filter"].simple-buttons .product-item .custom-control-label::after {
    visibility:hidden;
  }
  [id$="input-product-filter"].simple-buttons .product-item.auto.active {
    background-color: #333399;
    border-color: #333399;
    color: #fff;
  }
  [id$="input-product-filter"].simple-buttons .product-item.home.active {
    background-color: #669999;
    border-color: #669999;
    color: #fff;
  }
  [id$="input-product-filter"].simple-buttons .product-item.condo.active {
    background-color: #996699;
    border-color: #996699;
    color: #fff;
  }
  [id$="input-product-filter"].simple-buttons .product-item.renters.active {
    background-color: #7BBBC7;
    border-color: #7BBBC7;
    color: #fff;
  }
  .wrapper-product-filter {
    margin-left: 22px;
  }
.product-item .custom-control-label {
  padding: 4px 32px;
}
#wrapper-input-product-filter .product-item:focus-within {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
  box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
}
  </style>
<style lang="scss" scoped>
.renter_filter {
  border-color: $var-color-renter !important;
  color: $var-color-renter !important;
}
.renter_filter:hover {
  background-color: $var-color-renter !important;
  color: #ffffff !important;
}
.renter_filter.active {
  background-color: $var-color-renter !important;
  color: #ffffff !important;
}
.home_filter {
  border-color: $var-color-home !important;
  color: $var-color-home !important;
}
.home_filter:hover {
  background-color:$var-color-home !important;
  color: #ffffff !important;
}
.home_filter.active {
  background-color:$var-color-home !important;
  color: #ffffff !important;
}
.condo_filter {
  border-color: $var-color-condo !important;
  color: $var-color-condo !important;
}
.condo_filter:hover {
  background-color: $var-color-condo !important;
  color: #ffffff !important;
}
.condo_filter.active {
  background-color: $var-color-condo !important;
  color: #ffffff !important;
}
.auto_filter {
  border-color: $var-color-auto !important;
  color: $var-color-auto !important;
}
.auto_filter:hover{
  background-color:$var-color-auto;
  color: #ffffff !important;
}
.auto_filter.active {
  background-color:$var-color-auto;
  color: #ffffff !important;
}

</style>



// WEBPACK FOOTER //
// src/components/interactive/InputProductFilterAppointed.vue?65f9c68c